export function fromQueryParameters() {
  const queryParameters = new URLSearchParams(window.location.search);

  function getAppClientId(): string | null {
    return getQueryParameter("client_id");
  }

  function getResponseType(): string | null {
    return getQueryParameter("response_type");
  }

  function getScopes(): string | null {
    return getQueryParameter("scope");
  }

  function getRedirectUri(): string | null {
    return getQueryParameter("redirect_uri");
  }

  function getUsername(): string | null {
    return getQueryParameter("user_name");
  }

  function getConfirmationCode(): string | null {
    return getQueryParameter("confirmation_code");
  }

  function getState(): string | null {
    return getQueryParameter("state");
  }

  function doesRedirectUriExist(): boolean {
    return !!getRedirectUri();
  }

  function doAllLoginExist() : boolean{
    const clientId = getAppClientId();
    // const redirectUri = getRedirectUri();
    getState(); // not need to check it as optional
    // return !!(clientId && redirectUri);
    return !!(clientId);

  }

  function doAllStandardExist(): boolean {
    const clientId = getAppClientId();
    getState(); // not need to check it as optional
    return !!clientId;

  }

  function doAllVerificationExist():boolean {
    const clientId = getAppClientId();
    const username = getUsername();
    const confirmationCode = getConfirmationCode();
    getState(); // doesn't need checking..
    return !!(clientId && username && confirmationCode);

  }

  function doAllEmailVerificationExist(): boolean {
    const clientId = getAppClientId();
    const username = getUsername();
    return !!(clientId && username);

  }

  function clearVerificationParamters(){
    sessionStorage.removeItem("shiam_confirmation_code");
    sessionStorage.removeItem("shiam_user_name");
  }

  function getQueryParameter(queryParameterName: string): string | null {
    const queryParameterValue = queryParameters.get(queryParameterName);
    const sessionStorageKey = `shiam_${queryParameterName}`;
    let queryParameter: string | null = null;
    if (queryParameterValue) {
      const storedQueryParameterValue = queryParameterValue.split(" ").join("+");
      sessionStorage.setItem(sessionStorageKey, storedQueryParameterValue);
      queryParameter = storedQueryParameterValue;
    } else {
      const sessionStorageValue = sessionStorage.getItem(sessionStorageKey);
      if (sessionStorageValue) {
        queryParameter = sessionStorageValue;
      }
    }
    return queryParameter;
  }

  return {
    getAppClientId,
    getScopes,
    getResponseType,
    getRedirectUri,
    getUsername,
    getConfirmationCode,
    getState,
    doesRedirectUriExist,
    doAllLoginExist,
    doAllStandardExist,
    doAllVerificationExist,
    doAllEmailVerificationExist,
    clearVerificationParamters
  };
}
